import { Component, OnInit } from '@angular/core'
import { DynamicDialogConfig } from 'primeng/dynamicdialog'
import { EntityReference } from '../../../dto'

@Component({
  selector: 'jml-lib-dashboard-preview-dialog',
  templateUrl: './dashboard-preview-dialog.component.html',
  styleUrls: ['./dashboard-preview-dialog.component.scss']
})
export class DashboardPreviewDialogComponent implements OnInit {
  layout: string
  entityReference: EntityReference

  constructor(private config: DynamicDialogConfig) {}

  ngOnInit(): void {
    this.layout = this.config.data['layout']
    this.entityReference = this.config.data['entityReference']
  }
}
